import LeadsEmptyState from './LeadsEmptyState.component';

export default LeadsEmptyState;